import { DataBean } from "../DataBean";

export class AdquisitionContractVd extends DataBean {
    
    
    

    public async getAdquisitionContractCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionContractCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
  
    // public async getAgreementBalanceCatalogoPorPropiedadesRender(properties:any,maxRows:any): Promise<any> {
    //     return this.getCustomService("CacheOptions", "java.util.List_getAgreementBalanceCatalogoPorPropiedadesRender_java.util.Map_Number", [properties,maxRows]);
    // }
}